import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import CattlePerAcre from '@/pages/CattlePerAcre'
import CowCalfProfit from '@/pages/CowCalfProfit'
import CowCalfCost from '@/pages/CowCalfCost'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/cattle-per-acre-calculator', element: <CattlePerAcre /> },
  { path: '/cow-calf-profit-calculator', element: <CowCalfProfit /> },
  { path: '/cow-calf-cost-of-production', element: <CowCalfCost /> },
]

function App() {
  return useRoutes(routes)
}

export default App
